import "./style.css";
import React, { useState, useEffect } from "react";
import Tabs from "../../../components/Tabs";
import { Row, Col, Button } from "react-bootstrap";
import { RiDeleteBinLine } from "react-icons/ri";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { MdOutlineSave } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import Switch from "@mui/material/Switch";
import { CiStar } from "react-icons/ci";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { createAuditModelPath } from "../../../services/config";
import {
  saveUpdateDeleteAudit,
  initAuditState,
} from "../../../redux/slices/auditSlice";

const FormBuilder = () => {
  const [searchParams] = useSearchParams();
  const outletId = searchParams.get("outletId");


  console.log(outletId)

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();
  const auditState = useSelector((state) => state.audit);

  const [editFormTitle, setEditFormTitle] = useState(false);
  const [formTitle, setFormTitle] = useState("Enter Your Form Title");
  const [formFields, setFormFields] = useState([]);
  const [fieldType, setFieldType] = useState("");
  const [fieldLabel, setFieldLabel] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState("");
  const [multiChoiceOptions, setMultiChoiceOptions] = useState("");
  const [rating, setRating] = useState("");
  const [editRating, setEditRating] = useState("");
  const [isFileUpload, setIsFileUpload] = useState(false);
  const [isEditFileUpload, setIsEditFileUpload] = useState(false);
  const [linearScaleMin, setLinearScaleMin] = useState(1);
  const [linearScaleMax, setLinearScaleMax] = useState(5);
  const [ratingMax, setRatingMax] = useState(5);
  const [gridRows, setGridRows] = useState("");
  const [gridColumns, setGridColumns] = useState("");
  const [previewMode, setPreviewMode] = useState(false);
  const [editingFieldIndex, setEditingFieldIndex] = useState(null);
  const [editingOptions, setEditingOptions] = useState("");
  const [editingText, setEditingText] = useState("");

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleFileUploading = (e) => {
    setIsFileUpload(e.target.checked);
  };

  const handleEditFileUploading = (e) => {
    setIsEditFileUpload(e.target.checked);
  };

  const addField = () => {
    if (fieldLabel.trim() === "") return;

    let newField = {
      type: fieldType,
      label: fieldLabel,
      rating: fieldType == "File Upload" ? "NaN" : rating,
      isFileUpload: fieldType == "File Upload" ? "NaN" : isFileUpload,
      value: fieldType === "Checkbox" ? [] : "",
    };

    switch (fieldType) {
      case "Dropdown":
        newField.options = dropdownOptions.split(",");
        break;
      case "Multi Choice":
      case "Checkbox":
        newField.options = multiChoiceOptions.split(",");
        break;
      case "linear-scale":
        newField.min = linearScaleMin;
        newField.max = linearScaleMax;
        break;
      case "rating":
        newField.max = ratingMax;
        break;
      case "multiple-grid-choice":
      case "tick-box-grid":
        newField.rows = gridRows.split(",");
        newField.columns = gridColumns.split(",");
        break;
      default:
        break;
    }

    setFormFields([...formFields, newField]);
    setFieldLabel("");
    setDropdownOptions("");
    setMultiChoiceOptions("");
    setGridRows("");
    setGridColumns("");
    setRating("");
    setIsFileUpload(false);
  };

  const removeField = (index) => {
    const updatedFields = formFields.filter((_, i) => i !== index);
    setFormFields(updatedFields);
  };

  const startEditingText = (index) => {
    setEditingFieldIndex(index);
    setEditingText(formFields[index].label);
    setEditRating(formFields[index].rating);
    setIsEditFileUpload(formFields[index].isFileUpload);
  };

  const saveFieldText = (index) => {
    const updatedFields = [...formFields];
    updatedFields[index].label = editingText;
    updatedFields[index].rating = editRating;
    updatedFields[index].isFileUpload = isEditFileUpload;
    setFormFields(updatedFields);
    setEditingFieldIndex(null);
    setEditingText("");
  };

  const startEditingOptions = (index) => {
    setEditingFieldIndex(index);
    setEditingOptions(formFields[index].options.join(",")); // Initialize editing options
    setEditingText(formFields[index].label); // Initialize editing text
    setEditRating(formFields[index].rating);
    setIsEditFileUpload(formFields[index].isFileUpload);
  };

  const saveFieldOptions = (index) => {
    const updatedFields = [...formFields];
    updatedFields[index].label = editingText;
    updatedFields[index].rating = editRating;
    updatedFields[index].isFileUpload = isEditFileUpload;
    updatedFields[index].options = editingOptions.split(","); // Update options
    setFormFields(updatedFields);
    setEditingFieldIndex(null); // Exit edit mode
    setEditingText("");
  };

  const editFieldOptions = (index) => {
    setEditingFieldIndex(index);
  };

  const handleInputChange = (index, event) => {
    const values = [...formFields];
    if (values[index].type === "Checkbox") {
      // Checkbox ke liye array update karenge
      const selectedOptions = [...values[index].value];
      const optionValue = event.target.value;
      if (event.target.checked) {
        selectedOptions.push(optionValue);
      } else {
        const optionIndex = selectedOptions.indexOf(optionValue);
        if (optionIndex > -1) {
          selectedOptions.splice(optionIndex, 1);
        }
      }
      values[index].value = selectedOptions;
    } else {
      values[index].value = event.target.value;
    }
    setFormFields(values);
  };

  const handleRating = (value) => {
    if (value == "" || (value > 0 && value <= 10)) {
      setRating(value);
    }
  };

  const handleEditRating = (value) => {
    if (value == "" || (value > 0 && value <= 10)) {
      setEditRating(value);
    }
  };

  const handleFileUpload = (index, event) => {
    const values = [...formFields];
    values[index].value = event.target.files[0];
    setFormFields(values);
  };


  const renderField = (field, index) => {
    switch (field.type) {
      case "Text":
        return (
          <div className="mb-3 color-white">
            {editingFieldIndex === index ? (
              <>
                <input
                  type="text"
                  value={editingText}
                  placeholder="Enter question here."
                  onChange={(e) => setEditingText(e.target.value)}
                  className="universal-input-one"
                />
                {/* {field.value !== "formTitle" && ( */}
                <Row className="mt-2">
                  <Col
                    sm="6"
                    className="mb-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <label className="color-white">Rating</label>
                    <input
                      type="number"
                      max="10"
                      placeholder="Enter you rating here"
                      value={editRating}
                      className="fields universal-input-one"
                      onChange={(e) => handleEditRating(e.target.value)}
                    />
                  </Col>
                  <Col sm="6" className="mb-2">
                    File Upload{" "}
                    <Switch
                      checked={isEditFileUpload}
                      onChange={handleEditFileUploading}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Col>
                </Row>
                {/* )} */}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginTop: "5px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => saveFieldText(index)}
                  >
                    <MdOutlineSave />
                  </span>
                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => setEditingFieldIndex(null)}
                  >
                    <RxCross2 />
                  </span>
                </div>
              </>
            ) : (
              <>
                {/* {field.value !== "formTitle" && ( */}
                <input
                  type="text"
                  value={field.value}
                  placeholder="Will get user responses"
                  onChange={(e) => handleInputChange(index, e)}
                  readOnly
                  className="universal-input-one"
                />
                {/* )} */}

                <Row className="mt-2">
                  {field.isFileUpload && (
                    <Col sm="12" className="mb-2 color-white">
                      File Upload{" "}
                      <input
                        type="file"
                        disabled
                        className="universal-input-one"
                      />
                    </Col>
                  )}

                  {field.rating > 0 && (
                    <Col
                      sm="12"
                      className="mb-2"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <label className="color-white">Rating</label>
                      <label style={{ marginTop: "-2px" }} className="color-white">
                        {Array.from({ length: field.rating }, (_, i) => (
                          <CiStar key={i} style={{ fontSize: "18px" }} />
                        ))}
                      </label>
                    </Col>
                  )}
                </Row>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => startEditingText(index)}
                  >
                    <PiPencilSimpleLineBold />
                  </span>
                  {/* {field.value !== "formTitle" && ( */}
                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => removeField(index)}
                  >
                    <RiDeleteBinLine className="delete-icon" />
                  </span>
                  {/* )} */}
                </div>
              </>
            )}
          </div>
        );
      case "Dropdown":
        return (
          <div>
            {editingFieldIndex === index ? (
              <div>
                <div className="mb-2">
                  <input
                    type="text"
                    value={editingText}
                    placeholder="Type your answer here."
                    onChange={(e) => setEditingText(e.target.value)}
                    className="universal-input-one"
                  />
                </div>
                <input
                  type="text"
                  value={editingOptions}
                  onChange={(e) => setEditingOptions(e.target.value)}
                  className="universal-input-one"
                />

                <Row className="mt-2">
                  <Col
                    sm="6"
                    className="mb-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <label className="color-white">Rating</label>
                    <input
                      type="number"
                      max="10"
                      placeholder="Enter you rating here"
                      value={editRating}
                      className="fields universal-input-one"
                      onChange={(e) => handleEditRating(e.target.value)}
                      name="rating"
                    />
                  </Col>
                  <Col sm="6" className="mb-2">
                    File Upload{" "}
                    <Switch
                      checked={isEditFileUpload}
                      onChange={handleEditFileUploading}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Col>
                </Row>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginTop: "5px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => saveFieldOptions(index)}
                  >
                    <MdOutlineSave />
                  </span>

                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => setEditingFieldIndex(null)}
                  >
                    <RxCross2 />
                  </span>
                </div>
              </div>
            ) : (
              <div>
                <select
                  value={field.value}
                  onChange={(e) => handleInputChange(index, e)}
                  readOnly
                  className="universal-input-one"
                >
                  <option value="" style={{ color: "#fff" }}>
                    Select
                  </option>
                  {field.options.map((option, i) => (
                    <option key={i} value={option} style={{ color: "#fff" }}>
                      {option}
                    </option>
                  ))}
                </select>

                <Row className="mt-2">
                  {field.isFileUpload && (
                    <Col sm="12" className="mb-2 color-white">
                      File Upload{" "}
                      <input
                        type="file"
                        disabled
                        className="universal-input-one"
                      />
                    </Col>
                  )}

                  {field.rating > 0 && (
                    <Col
                      sm="12"
                      className="mb-2"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <label className="color-white">Rating</label>
                      <label style={{ marginTop: "-2px" }} className="color-white">
                        {Array.from({ length: field.rating }, (_, i) => (
                          <CiStar key={i} style={{ fontSize: "18px" }} />
                        ))}
                      </label>
                    </Col>
                  )}
                </Row>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginTop: "5px",
                    marginBottom: "15px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => startEditingOptions(index)}
                  >
                    <PiPencilSimpleLineBold />
                  </span>

                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => removeField(index)}
                  >
                    <RiDeleteBinLine className="delete-icon" />
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      case "Multi Choice":
      case "Checkbox":
        return (
          <div className="mb-2">
            {editingFieldIndex === index ? (
              <div>
                <div className="mb-2">
                  <input
                    type="text"
                    value={editingText}
                    placeholder="Type your answer here."
                    onChange={(e) => setEditingText(e.target.value)}
                    className="universal-input-one"
                  />
                </div>

                <input
                  type="text"
                  value={editingOptions}
                  onChange={(e) => setEditingOptions(e.target.value)}
                  placeholder="Enter options (comma separated)"
                  className="universal-input-one"
                />

                <Row className="mt-2">
                  <Col
                    sm="6"
                    className="mb-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <label className="color-white">Rating</label>
                    <input
                      type="number"
                      max="10"
                      placeholder="Enter you rating here"
                      value={editRating}
                      className="fields universal-input-one"
                      onChange={(e) => handleEditRating(e.target.value)}
                      name="rating"
                    />
                  </Col>
                  <Col sm="6" className="mb-2">
                    File Upload{" "}
                    <Switch
                      checked={isEditFileUpload}
                      onChange={handleEditFileUploading}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Col>
                </Row>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginTop: "5px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => saveFieldOptions(index)}
                  >
                    <MdOutlineSave />
                  </span>

                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => setEditingFieldIndex(null)}
                  >
                    <RxCross2 />
                  </span>
                </div>
              </div>
            ) : (
              <div>
                {field.options.map((option, i) => (
                  <div
                    key={i}
                    className={
                      field.type === "Checkbox"
                        ? "checkbox-option"
                        : "radio-option"
                    }
                  >
                    <input
                      type={field.type === "Checkbox" ? "checkbox" : "radio"}
                      name={field.label}
                      value={option}
                      checked={
                        field.type === "Checkbox"
                          ? field.value.includes(option)
                          : field.value === option
                      }
                      onChange={(e) => handleInputChange(index, e)}
                      readOnly
                      className="universal-input-one"
                    />
                    {option}
                  </div>
                ))}

                <Row className="mt-2">
                  {field.isFileUpload && (
                    <Col sm="12" className="mb-2 color-white">
                      File Upload{" "}
                      <input
                        type="file"
                        disabled
                        className="universal-input-one"
                      />
                    </Col>
                  )}

                  {field.rating > 0 && (
                    <Col
                      sm="12"
                      className="mb-2"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <label className="color-white">Rating</label>
                      <label style={{ marginTop: "-2px" }} className="color-white">
                        {Array.from({ length: field.rating }, (_, i) => (
                          <CiStar key={i} style={{ fontSize: "18px" }} />
                        ))}
                      </label>
                    </Col>
                  )}
                </Row>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => startEditingOptions(index)}
                  >
                    <PiPencilSimpleLineBold />
                  </span>

                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => removeField(index)}
                  >
                    <RiDeleteBinLine className="delete-icon" />
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      case "File Upload":
        return (
          <div className="mb-3">
            {editingFieldIndex === index ? (
              <>
                <input
                  type="text"
                  value={editingText}
                  placeholder="Type your answer here."
                  onChange={(e) => setEditingText(e.target.value)}
                  className="universal-input-one"
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginTop: "5px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => saveFieldText(index)}
                  >
                    <MdOutlineSave />
                  </span>

                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => setEditingFieldIndex(null)}
                  >
                    <RxCross2 />
                  </span>
                </div>
              </>
            ) : (
              <>
                <input
                  type="file"
                  onChange={(e) => handleFileUpload(index, e)}
                  className="universal-input-one"
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => startEditingText(index)}
                  >
                    <PiPencilSimpleLineBold />
                  </span>

                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => removeField(index)}
                  >
                    <RiDeleteBinLine className="delete-icon" />
                  </span>
                </div>
              </>
            )}
          </div>
        );
      case "linear-scale":
        return (
          <div className="linear-scale">
            <span>{field.min}</span>
            <input
              type="range"
              min={field.min}
              max={field.max}
              value={field.value}
              onChange={(e) => handleInputChange(index, e)}
            />
            <span>{field.max}</span>
          </div>
        );
      case "rating":
        return (
          <div className="rating-stars">
            {[...Array(field.max)].map((_, i) => (
              <span
                key={i}
                onClick={() =>
                  handleInputChange(index, { target: { value: i + 1 } })
                }
                className={field.value > i ? "active" : ""}
              >
                ★
              </span>
            ))}
          </div>
        );
      case "multiple-grid-choice":
      case "tick-box-grid":
        return (
          <table className="grid-table">
            <thead>
              <tr>
                <th></th>
                {field.columns.map((column, i) => (
                  <th key={i}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {field.rows.map((row, i) => (
                <tr key={i}>
                  <td>{row}</td>
                  {field.columns.map((column, j) => (
                    <td key={j}>
                      {field.type === "multiple-grid-choice" ? (
                        <input
                          type="radio"
                          name={row}
                          onChange={(e) => handleInputChange(index, e)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          onChange={(e) => handleInputChange(index, e)}
                        />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        );
      case "Date":
        return (
          <div className="mb-3">
            {editingFieldIndex === index ? (
              <>
                <input
                  type="text"
                  value={editingText}
                  placeholder="Type your answer here."
                  onChange={(e) => setEditingText(e.target.value)}
                />
                <Row className="mt-2">
                  <Col
                    sm="6"
                    className="mb-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <label>Rating</label>
                    <input
                      type="number"
                      max="10"
                      placeholder="Enter you rating here"
                      value={editRating}
                      className="fields"
                      onChange={(e) => handleEditRating(e.target.value)}
                      name="rating"
                    />
                  </Col>
                  <Col sm="6" className="mb-2">
                    File Upload{" "}
                    <Switch
                      checked={isEditFileUpload}
                      onChange={handleEditFileUploading}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Col>
                </Row>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginTop: "5px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => saveFieldText(index)}
                  >
                    <MdOutlineSave />
                  </span>

                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => setEditingFieldIndex(null)}
                  >
                    <RxCross2 />
                  </span>
                </div>
              </>
            ) : (
              <>
                <input
                  type="date"
                  value={field.value}
                  onChange={(e) => handleInputChange(index, e)}
                  readOnly
                  className="universal-input-one"
                />

                <Row className="mt-2">
                  {field.isFileUpload && (
                    <Col sm="12" className="mb-2 color-white">
                      File Upload{" "}
                      <input
                        type="file"
                        disabled
                        className="universal-input-one"
                      />
                    </Col>
                  )}

                  {field.rating > 0 && (
                    <Col
                      sm="12"
                      className="mb-2"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <label className="color-white">Rating</label>
                      <label style={{ marginTop: "-2px" }} className="color-white">
                        {Array.from({ length: field.rating }, (_, i) => (
                          <CiStar key={i} style={{ fontSize: "18px" }} />
                        ))}
                      </label>
                    </Col>
                  )}
                </Row>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <span
                    className="edit-options-button"
                    onClick={() => startEditingText(index)}
                  >
                    <PiPencilSimpleLineBold />
                  </span>

                  <span
                    type="button"
                    className="remove-field-button"
                    onClick={() => removeField(index)}
                  >
                    <RiDeleteBinLine className="delete-icon" />
                  </span>
                </div>
              </>
            )}
          </div>
        );
      case "time":
        return (
          <input
            type="time"
            value={field.value}
            onChange={(e) => handleInputChange(index, e)}
          />
        );
      default:
        return null;
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const body = {
      path: createAuditModelPath,
      data: {
        userId: user.user_id,
        outletId,
        auditModelName: formTitle,
        auditQuestions: formFields,
      },
    };

    dispatch(saveUpdateDeleteAudit(body));
  };

  useEffect(() => {
    if (auditState.auditSuccess || auditState.auditError) {
      auditState.auditSuccess
        ? toast.success(auditState.auditMessage)
        : toast.error(auditState.auditMessage);

      dispatch(initAuditState());
      if (auditState.auditSuccess) {
        setTimeout(() => {
          navigate(`/questionnaire?outletId=${outletId}`);
        }, 3000);
      }
    }
  }, [auditState, dispatch]);

  const handleBack = (e) => {
    // e.preventDefault()
    // setTimeout(() => {
    //   navigate(`/questionnaire?outletId=${outletId}`)
    // }, 3000)

  }

  return (
    <div className="form-builder">
      <div
        className="page-top-bar"
        style={{
          position: "fixed",
          top: "75px",
          height: "40px",
          width: "100%",
          zIndex: "2"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gap: "10px",
            marginTop: "15px",
          }}
        >
          <Link to={`/questionnaire?outletId=${outletId}`}
            style={
              {
                position: "relative",
                top: "-8px"
              }
            }
          >
          <ArrowBackIcon sx={{ scale: 1 }} className="color-white" style={{
            cursor: "pointer", position: "relative"
          }}  />
          </Link>
          <h1 style={{ fontSize: "20px", fontWeight: "400" }} className="color-white">
            Create Questionnaire
          </h1>
        </div>
      </div>
      <div className="restaurant-container" style={{ padding: "0 40px" }}>
        <div className="form-builder-container">
          <div className="form-builders builder dark-bg-color">
            <Row>
              <Col sm="12">
                <Tabs setFieldType={setFieldType} />
              </Col>
            </Row>
            {fieldType ? (
              <Row style={{ marginTop: "-30px" }}>
                <Col sm="12" className="mb-2">
                  <label className="color-white">Question</label>
                  <input
                    type="text"
                    placeholder={`Enter your question`}
                    value={fieldLabel}
                    className="fields universal-input-one"
                    onChange={(e) => setFieldLabel(e.target.value)}
                  />
                </Col>

                {fieldType === "Dropdown" && (
                  <Col sm="12" className="mb-2">
                    <label className="color-white">Options</label>
                    <input
                      type="text"
                      placeholder="Dropdown Options (comma separated)"
                      value={dropdownOptions}
                      className="fields universal-input-one"
                      onChange={(e) => setDropdownOptions(e.target.value)}
                    />
                  </Col>
                )}

                {(fieldType === "Multi Choice" || fieldType === "Checkbox") && (
                  <Col sm="12" className="mb-2">
                    <label className="color-white">Options</label>
                    <input
                      type="text"
                      placeholder="Options (comma separated)"
                      value={multiChoiceOptions}
                      className="fields universal-input-one"
                      onChange={(e) => setMultiChoiceOptions(e.target.value)}
                    />
                  </Col>
                )}

                {fieldType !== "File Upload" && (
                  <>
                    <Col
                      sm="6"
                      className="mb-2"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <label className="color-white">Rating</label>
                      <input
                        type="number"
                        max="10"
                        placeholder="Enter you rating here"
                        value={rating}
                        className="fields universal-input-one"
                        onChange={(e) => handleRating(e.target.value)}
                        name="rating"
                      />
                    </Col>
                    <Col sm="6" className="mb-2">
                      File Upload{" "}
                      <Switch
                        checked={isFileUpload}
                        onChange={handleFileUploading}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Col>
                  </>
                )}

                <Col sm="12">
                  <button onClick={addField} className="dark-bg-color border-gray" >Add Question</button>
                </Col>
              </Row>
            ) : (
              <h3
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                className="color-white"
              >
                Add Fields
              </h3>
            )}
          </div>
          {/* Preview form ------------------------------------------ */}
          <div className="form-builders preview dark-bg-color">
            <div className="form-preview">
              <h4 className="color-white">Form Preview</h4>
              <form onSubmit={handleSubmit}>
                {editFormTitle ? (
                  <>
                    <input
                      type="text"
                      value={formTitle}
                      placeholder="Enter form title here."
                      onChange={(e) => setFormTitle(e.target.value)}
                      className="universal-input-one"
                    />

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "5px",
                        marginBottom: "15px",
                      }}
                    >
                      <span
                        className="edit-options-button"
                        onClick={() => setEditFormTitle(false)}
                      >
                        <MdOutlineSave />
                      </span>
                      <span
                        type="button"
                        className="remove-field-button"
                        onClick={() => setEditFormTitle(false)}
                      >
                        <RxCross2 />
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <label className="color-white">
                      {" "}
                      <strong>Form Title:</strong> {formTitle}
                    </label>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      <span
                        className="edit-options-button"
                        onClick={() => setEditFormTitle(true)}
                      >
                        <PiPencilSimpleLineBold />
                      </span>
                    </div>
                  </>
                )}

                {formFields.map((field, index) => (
                  <div key={index}>
                    <hr style={{ border: "1px solid lightgray" }} />

                    <label className="color-white">
                      {index + 1}.&nbsp; {field.label}
                    </label>
                    {renderField(field, index)}
                  </div>
                ))}

                {formFields != "" ? (
                  <div className="preview-form-buttons">
                    <button type="submit" className=" pure-dark-color">
                      Submit
                    </button>
                  </div>
                ) : null}
              </form>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default FormBuilder;
